
import { AbstractControl, ValidationErrors, FormGroup, FormControl, ValidatorFn } from '@angular/forms';

export class Validacoes {

  static ValidaCpf(controle: AbstractControl) {
    const cpf = controle.value;
    let soma = 0;
    let resto = 0;
    let primeiro: boolean;
    let segundo: boolean;
    let digito = 0;

    const regex = new RegExp('[0-9]{11}');
    if (cpf) {
      if (cpf.length === 11) {
        if (
          cpf === '00000000000' || cpf === '11111111111' ||
          cpf === '22222222222' || cpf === '33333333333' ||
          cpf === '44444444444' || cpf === '55555555555' ||
          cpf === '66666666666' || cpf === '77777777777' ||
          cpf === '88888888888' || cpf === '99999999999' ||
          !regex.test(cpf)
        ) {
          primeiro = false;
        } else {
          /* validacao 1 digito verificador */
          for (let i = 1; i <= 9; i++) {
            soma = soma + parseInt(cpf.substring(i - 1, i), 10) * (11 - i);
          }
          resto = soma % 11;
          if (resto === 0 || resto === 1) { resto = 0; }
          digito = 11 - resto;
          if (digito === parseInt(cpf.substring(9, 10), 10)) { primeiro = true; }

          /* validaçao do segundo digito */
          soma = 0;
          for (let i = 1; i <= 10; i++) {
            soma = soma + parseInt(cpf.substring(i - 1, i), 10) * (12 - i);
          }
          resto = soma % 11;
          if (resto === 0 || resto === 1) { resto = 0; }
          digito = 11 - resto;
          if (digito === parseInt(cpf.substring(10, 11), 10)) { segundo = true; }
        }
        if (primeiro && segundo) { return null; }

        return { cpfInvalido: true };

      }
    }
  }

  /* 14.562.225/0001-46 teste valido*/
  static ValidaCnpj(controle: AbstractControl) {
    const cnpj = controle.value;
    let primeiro = false;
    let segundo = false;
    let soma = 0;
    let resto = 0;
    let digito = 0;
    let peso = 2;
    let num = 0;

    const regex = new RegExp('[0-9]{14}');

    if (cnpj) {
      if (cnpj.length === 14) {
        if (
          cnpj === '00000000000000' || cnpj === '11111111111111' ||
          cnpj === '22222222222222' || cnpj === '33333333333333' ||
          cnpj === '44444444444444' || cnpj === '55555555555555' ||
          cnpj === '66666666666666' || cnpj === '77777777777777' ||
          cnpj === '88888888888888' || cnpj === '99999999999999'
          || !regex.test(cnpj)
        ) {
          primeiro = false;
        } else {

          for (let i = 11; i >= 0; i--) {
            num = parseInt(cnpj.substring(i + 1, i), 10);
            soma = soma + (num * peso);
            peso++;
            if (peso === 10) {
              peso = 2;
            }
          }

          resto = soma % 11;
          if (resto === 0 || resto === 1) { resto = 0; }
          digito = 11 - resto;
          if (digito === parseInt(cnpj.substring(12, 13), 10)) { primeiro = true; }

          soma = 0;
          peso = 2;
          for (let i = 12; i >= 0; i--) {
            num = parseInt(cnpj.substring(i + 1, i), 10);
            soma = soma + (num * peso);
            peso++;
            if (peso === 10) {
              peso = 2;
            }
          }
          resto = soma % 11;
          if (resto === 0 || resto === 1) { resto = 0; }
          digito = 11 - resto;
          if (digito === parseInt(cnpj.substring(13, 14), 10)) { segundo = true; }

        }

        if (primeiro && segundo) { return null; }

        return { cnpjInvalido: true };
      }
    }
  }


  static arePasswordsEqual(confirmarSenhaKey: string, senhaKey: string) {
    return (group: FormGroup): { [key: string]: any } => {
      const senha = group.controls[senhaKey];
      const confirmarSenha = group.controls[confirmarSenhaKey];

      if (senha.value !== confirmarSenha.value) {
        confirmarSenha.setErrors({ senhasNaoCoincidem: true });
        return {
          senhasNaoCoincidem: true
        };
      }
    };
  }

  static validaPrazos(prazoValidacaoPvaKey: string, prazoAuditoriaEletronicaKey: string,
    prazoAssinaturaKey: string, prazoTransmissaoKey: string) {
    return (group: FormGroup): { [key: string]: any } => {
      const prazoValidacaoPva = group.controls[prazoValidacaoPvaKey];
      const prazoAuditoriaEletronica = group.controls[prazoAuditoriaEletronicaKey];
      const prazoAssinatura = group.controls[prazoAssinaturaKey];
      const prazoTransmissao = group.controls[prazoTransmissaoKey];

      if (prazoAuditoriaEletronica !== null &&
        prazoValidacaoPva >= prazoAuditoriaEletronica &&
        prazoAuditoriaEletronica >= prazoAssinatura &&
        prazoAssinatura >= prazoTransmissao ||
        prazoValidacaoPva >= prazoAssinatura &&
        prazoAssinatura >= prazoTransmissao) {
        prazoValidacaoPva.setErrors({ prazosInvalidos: true });
        return {
          prazosInvalidos: true
        };
      }
    };
  }

  static validaNovaSenha(control: AbstractControl) : ValidationErrors | null {
    var erros = {}
    var senha = control.value

    if(!senha) {
      return {vazia: true}
    }
  
    //1 caractere Maiúsculo
    if(!senha.match(/[A-Z]+/)){
      erros['maiuscula'] = true
    }
  
    //1 caractere minúsculo
    if(!senha.match(/[a-z]+/)){
      erros['minuscula'] = true
    }
  
    //1 número
    if(!senha.match(/[1-9]+/)){
      erros['numero'] = true
    }
  
    //1 especial
    if(!senha.match(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?` ~]+/)){
      erros['especial'] = true
    }
  
    return erros;
  }
  
}

/**
 * Esse validator só permite datas igual ou maior que hoje
 * @param data data a ser validada
 */
export function atLeastTodayValidator(data: AbstractControl): ValidationErrors {

  if (!data.value) {
    return null;
  }

  const retornoRegex = data.value.match(/(\d{4})\-(\d{2})\-(\d{2})/);
  const hoje = new Date();
  if (retornoRegex) {
    if (parseInt(retornoRegex[1], 10) < hoje.getFullYear()) {
      return { dataAntesDeHoje: { value: data.value } };
    }

    if (parseInt(retornoRegex[1], 10) === hoje.getFullYear()
      && parseInt(retornoRegex[2], 10) < (hoje.getMonth() + 1)) {
      return { dataAntesDeHoje: { value: data.value } };
    }

    if (parseInt(retornoRegex[1], 10) === hoje.getFullYear()
      && parseInt(retornoRegex[2], 10) === (hoje.getMonth() + 1)
      && parseInt(retornoRegex[3], 10) < (hoje.getDate())) {
      return { dataAntesDeHoje: { value: data.value } };
    }


    return null;
  } else {
    return { dataInvalida: { value: data.value } };
  }

}

/**
 * Esse validator só aceita datas no máximo igual a hoje.
 */
export function atMaxTodayValidator(data: AbstractControl): ValidationErrors {

  if (!data.value) {
    return null;
  }

  const retornoRegex = data.value.match(/(\d{4})\-(\d{2})\-(\d{2})/);
  const hoje = new Date();
  if (retornoRegex) {
    if (parseInt(retornoRegex[1], 10) > hoje.getFullYear()) {
      return { dataDepoisDeHoje: { value: data.value } };
    }

    if (parseInt(retornoRegex[1], 10) === hoje.getFullYear()
      && parseInt(retornoRegex[2], 10) > (hoje.getMonth() + 1)) {
      return { dataDepoisDeHoje: { value: data.value } };
    }

    if (parseInt(retornoRegex[1], 10) === hoje.getFullYear()
      && parseInt(retornoRegex[2], 10) === (hoje.getMonth() + 1)
      && parseInt(retornoRegex[3], 10) > (hoje.getDate())) {
      return { dataDepoisDeHoje: { value: data.value } };
    }


    return null;
  } else {
    return { dataInvalida: { value: data.value } };
  }

}

// TODO: Fazer esse validator
/**
 * Verifica se a data de inicio é válida, e menor ou igual que a data de fim
 * @param data Campo bindado
 * @param fim valor da data do outro campo
 */
export function compararDateRangeInicioValidator(data: AbstractControl, fim: Date): ValidationErrors {
  const retornoRegex = data.value.match(/(\d{4})\-(\d{2})\-(\d{2})/);
  if (!retornoRegex) {
    return { dataInvalida: { value: data.value } };
  }

  if (!fim) {
    return null;
  }

  return null;
}

// TODO: Fazer esse validator
/**
 * Verifica se a data de fim é válida, e maior ou igual que a data de inicio
 * @param data
 * @param inicio valor da data do outro campo
 */
export function compararDateRangeFimValidator(data: AbstractControl, inicio: Date): ValidationErrors {
  const retornoRegex = data.value.match(/(\d{4})\-(\d{2})\-(\d{2})/);
  if (!retornoRegex) {
    return { dataInvalida: { value: data.value } };
  }

  if (!inicio) {
    return null;
  }

  return null;
}

export function validaValorEntreRange(minSource: FormControl, maxSource: FormControl, maxValue: number = 20) {
  return (target: FormControl): { [key: string]: any } => {
    const minSourceValue = minSource ? minSource.value : 2;
    const maxSourceValue = maxSource ? maxSource.value : maxValue;
    if (minSourceValue > maxSourceValue) {
      return {valorNaoEmRange: 'Ajuste os outros campos primeiro'};
    }
    if (target.value > maxValue) {
      return {valorNaoEmRange: `Valor deve ser menor ou igual a ${maxValue}`};
    }
    if (minSourceValue && target.value < minSourceValue || maxSourceValue && target.value > maxSourceValue) {
      if (minSourceValue && maxSourceValue) {
        return { valorNaoEmRange: `Valor deve estar entre ${minSourceValue} e ${maxSourceValue}` };
      } else if (minSourceValue) {
        return { valorNaoEmRange: `Valor deve ser maior que  ${minSourceValue}` };
      }
    }
  }
}

